/* eslint-disable */
export default function pixelEvent(params) {
  params.ncrd = new Date().getTime();
  params["user-agent"] = navigator.userAgent;
  let str = "";
  for (var key in params) {
    if (str !== "") {
      str += "&";
    }
    str += key + "=" + params[key];
  }

  var img = new Image();
  img.src = "/pixel.gif?" + str;
}
